import {isNullOrUndefined} from 'util';

const transformLinksToItems = (linkedRefs: any[]) => {
  const returnableList = [];
  linkedRefs.forEach((itemInfo: { label: string, href: string }) => {
    returnableList.push({label: itemInfo.label, _links: {self: {href: itemInfo.href}}});
  });

  return returnableList;
};

const findListableItems = (data) => {
  let returnable = data._embedded ? data._embedded.item : null;
  const hasLinks = !isNullOrUndefined(data._links) && !isNullOrUndefined(data._links.item);

  if (!returnable && hasLinks) {
    returnable = transformLinksToItems(data._links.item);
  }

  return returnable;
};

export function RestangularConfigFactory(RestangularProvider) {

  const BASE_URL = '/api';
  const contentType = 'application/hal+json';

  RestangularProvider.setBaseUrl(BASE_URL);
  RestangularProvider.setDefaultHeaders({
    'Content-Type': contentType,
    'Accept': contentType,
  });
  RestangularProvider.setRestangularFields({
    selfLink: '_links.self.href',
  });
  RestangularProvider.setPlainByDefault(true);
  RestangularProvider.setResponseInterceptor((data, operation) => {
    console.log('intercept: ', data, operation);
    let returnValue = data;
    if (operation === 'getList') {
      returnValue = findListableItems(data);
    }

    if (operation === 'remove') {
      returnValue = [];
    }

    return returnValue;
  });
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/base-app/lib/restangular-config.ts